/**
 * Zustand slice for the report editor's live session: the ProseMirror view/ref,
 * which report is open, current text-selection state, and staged preview content.
 * Consumed by reportEditorPage/ (ReportEditorPage, ReportEditor, ReportHeader, etc.).
 */
export const createEditorSessionSlice = (set, get) => ({
    rteRef: null,
    editorView: null, // ProseMirror editor view reference
    reportId: null, // Current report ID for Firestore operations
    isSelectedText: false,
    activeReferenceMarkerId: null, // Active reference marker ID at caret position (highest start position)
    activeWikidataEntity: null, // Active Wikidata payload used by editor/preview popover synchronization

    setIsSelectedText: (isSelected) => set({isSelectedText: isSelected}),

    setActiveReferenceMarkerId: (activeReferenceMarkerId) => set({activeReferenceMarkerId}),

    setActiveWikidataEntity: (activeWikidataEntity) => set({activeWikidataEntity}),

    clearActiveWikidataEntity: () => set({activeWikidataEntity: null}),

    setContent: (content) => set({content}),

    /** Staged PM JSON + references when opening preview from the editor (before DB persist). */
    previewDraft: null,
    setPreviewDraft: (previewDraft) => set({previewDraft}),
    clearPreviewDraft: (reportId) =>
        set((state) => {
            if (!reportId || state.previewDraft?.reportId !== String(reportId)) {
                return state;
            }
            return {previewDraft: null};
        }),

    setRteRef: (ref) => set({rteRef: ref}),

    setEditorView: (view) => set({editorView: view}),

    setReportId: (reportId) => set({reportId}),
});
